import React from 'react';

const SmallWarningIcon = () => {
	return (
		<svg
			data-testid='small-warning-icon'
			fill='none'
			height='16'
			viewBox='0 0 16 16'
			width='16'
		>
			<path
				d='M8 6.5V9'
				stroke='#D92644'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M7.13739 2.50004L1.6374 12C1.54978 12.1518 1.50357 12.3239 1.50342 12.4992C1.50326 12.6744 1.54916 12.8466 1.63651 12.9985C1.72386 13.1504 1.8496 13.2767 2.00113 13.3647C2.15266 13.4528 2.32466 13.4994 2.4999 13.5H13.4999C13.6751 13.4994 13.8471 13.4528 13.9987 13.3647C14.1502 13.2767 14.2759 13.1504 14.3633 12.9985C14.4506 12.8466 14.4965 12.6744 14.4964 12.4992C14.4962 12.3239 14.45 12.1518 14.3624 12L8.86239 2.50004C8.77543 2.34808 8.64987 2.22179 8.49841 2.13396C8.34695 2.04613 8.17498 1.99988 7.99989 1.99988C7.82481 1.99988 7.65284 2.04613 7.50138 2.13396C7.34992 2.22179 7.22436 2.34808 7.13739 2.50004V2.50004Z'
				stroke='#D92644'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M8 11.75C8.27614 11.75 8.5 11.5261 8.5 11.25C8.5 10.9739 8.27614 10.75 8 10.75C7.72386 10.75 7.5 10.9739 7.5 11.25C7.5 11.5261 7.72386 11.75 8 11.75Z'
				fill='#D92644'
			/>
		</svg>
	);
};

export default SmallWarningIcon;
